/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1HIcon16Light = forwardRef('ArrowDim1HIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.853 3.648a.5.5 0 0 1 0 .707L2.207 7.001h11.585l-2.646-2.646a.5.5 0 1 1 .707-.707l2.793 2.793a1.5 1.5 0 0 1 0 2.121l-2.791 2.792a.5.5 0 0 1-.707-.708l2.645-2.645H2.206l2.646 2.645a.5.5 0 0 1-.707.708L1.353 8.562a1.5 1.5 0 0 1 0-2.121l2.793-2.793a.5.5 0 0 1 .707 0Z" })));
});
